import React, { Component } from 'react'
/*Redux */
import 'firebase/firestore'
import 'firebase/auth'
import { connect } from 'react-redux'
import propTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Confirm, Popup } from 'semantic-ui-react'

/*Actions */
import {
    setStateSongParent,
    emptyError,
    fetchAllSongParent,
    getSongParentData
} from '../../Actions/SongParentAction'

class SetStateSongParent extends Component {
    state = { open: false }
    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })

    setStateSongParent(id, status) {
        this.props.setStateSongParent(id, status)
    }

    handleSubmit = (e) => {

        const { id, status } = this.props;

        if (status === "SUSPENDED") {
            this.setStateSongParent(id, "DEFAULT");

        } else {
            this.setStateSongParent(id, "SUSPENDED");
        }
        this.close();
    }


    render() {
        const { success, error, status, id, sentFrom } = this.props;

        let contentPreview = null;

        if (success === false) {
            alert("Error: " + error);
            this.props.emptyError();
        }
        else if (success === true) {
            alert("Song Parent status updated successfully");
            this.props.emptyError();

            // if the requesst come from All songParent then
            // fetch all SongsParent to update 
            // the new data
            if (sentFrom === "AllSongParents") {
                this.props.fetchAllSongParent();
            }

            // if the requesst come from ViewSongParent then
            // get Song parent data to update 
            // the suspended Song
            if (sentFrom === "ViewSongParent") {
                this.props.getSongParentData(id);
            }
        }
        if (status === "SUSPENDED") {
            contentPreview = (
                <Popup trigger={
                    <button className="seriesCardButtons" onClick={this.open}>
                        <i >
                            <FontAwesomeIcon icon="play" />
                        </i>
                    </button>
                }
                    content='Tap to Active'
                    position='top center'
                />

            )
        }
        else {
            contentPreview = (
                <Popup trigger={
                    <button className="seriesCardButtons"
                        onClick={this.open}>||</button>}
                    content='Tap to Suspend'
                    position='top center'
                />

            )
        }


        return (
            <span >
                {contentPreview}
                <Confirm id="modal" open={this.state.open} onCancel={this.close} onConfirm={this.handleSubmit} />
            </span>)
    }
}

SetStateSongParent.propTypes = {
    setStateSongParent: propTypes.func.isRequired,
    fetchAllSongParent: propTypes.func.isRequired,
    getSongParentData: propTypes.func.isRequired,
}
const mapStateToProps = state =>
({
    success: state.songParent.setting_state_song_parent_sucessfully,
    error: state.songParent.setting_state_song_parent_error
})

export default connect
    (mapStateToProps,
        {
            setStateSongParent,
            emptyError,
            fetchAllSongParent,
            getSongParentData
        })
    (SetStateSongParent)
